import { z } from "zod";

import { PEOPLE_QUERY_MAX_LENGTH, PERSON_STATUSES, personLabelSchema } from "@ravnar/api-contract";

/**
 * Where People & HR's list stands: its page, the one team or role it shows, the status it shows and what its search box
 * holds. The list keeps them in its address, and a person's page keeps them in its own, so that the person's Back
 * link, and the removal that ends on the list, land where the person was opened from rather than on the first page of
 * everyone.
 */
export const peopleListSearchSchema = z.object({
	/** A page link from the API, which the page never reads; the first page when there is none. */
	page: z.string().optional().catch(undefined),
	/** The one team the list shows, chosen on the Teams donut; every team when there is none. */
	team: personLabelSchema.optional().catch(undefined),
	/** The one role the list shows, chosen on the Roles donut; every role when there is none. */
	role: personLabelSchema.optional().catch(undefined),
	/** The one status the list shows, chosen from its pills; every status when there is none. */
	status: z.enum(PERSON_STATUSES).optional().catch(undefined),
	/** What the search box holds, which the API matches against names; nothing when there is none. */
	q: z.string().max(PEOPLE_QUERY_MAX_LENGTH).optional().catch(undefined),
});
export type PeopleListSearch = z.infer<typeof peopleListSearchSchema>;
